import React, { useState, useEffect } from 'react';
import axiosClient, { UPLOADS_BASE_URL } from '../../axios_client';

const UpdateAdminEvents = ({ isOpen, onClose, event, onEventUpdated }) => {
    const [eventName, setEventName] = useState('');
    const [description, setDescription] = useState('');
    const [imageFiles, setImageFiles] = useState([]);
    const [existingImages, setExistingImages] = useState([]);
    const [error, setError] = useState('');

    // Define base URL for images (adjust as needed for production)
    const BASE_URL = UPLOADS_BASE_URL; // Use https://sunflower-resort.com for production

    useEffect(() => {
        if (event) {
            setEventName(event.event_name || '');
            setDescription(event.description || '');
            setExistingImages(event.images || []);
        }
    }, [event]);

    const handleImageChange = (e) => {
        setImageFiles(Array.from(e.target.files));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const formData = new FormData();
            formData.append('event_name', eventName);
            formData.append('description', description);
            imageFiles.forEach((file) => formData.append('images', file));

            await axiosClient.put(`/events/${event.id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });
            onEventUpdated();
            onClose();
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to update event');
        }
    };

    // Normalize image URL to ensure it starts with a slash
    const getImageUrl = (img) => {
        const path = img.startsWith('/') ? img : `/${img}`;
        return `${BASE_URL}${path}`;
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4 sm:px-6">
            <div className="bg-white p-4 sm:p-6 rounded-lg shadow-lg w-full max-w-xs sm:max-w-md">
                <h2 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 text-[#12392B]">
                    Update Event
                </h2>
                {error && (
                    <p className="text-red-500 text-sm sm:text-base mb-3 sm:mb-4">
                        {error}
                    </p>
                )}
                <form onSubmit={handleSubmit}>
                    <div className="mb-3 sm:mb-4">
                        <label
                            className="block text-[#12392B] text-sm sm:text-base mb-1 sm:mb-2"
                            htmlFor="eventName"
                        >
                            Event Name
                        </label>
                        <input
                            type="text"
                            id="eventName"
                            value={eventName}
                            onChange={(e) => setEventName(e.target.value)}
                            className="w-full p-2 sm:p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#E6A71A] text-sm sm:text-base"
                            required
                            aria-label="Event Name"
                        />
                    </div>
                    <div className="mb-3 sm:mb-4">
                        <label
                            className="block text-[#12392B] text-sm sm:text-base mb-1 sm:mb-2"
                            htmlFor="description"
                        >
                            Description
                        </label>
                        <textarea
                            id="description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            className="w-full p-2 sm:p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#E6A71A] text-sm sm:text-base"
                            rows="4"
                            aria-label="Description"
                        />
                    </div>
                    <div className="mb-3 sm:mb-4">
                        <label className="block text-[#12392B] text-sm sm:text-base mb-1 sm:mb-2">
                            Existing Images
                        </label>
                        {existingImages.length > 0 ? (
                            <div className="grid grid-cols-2 gap-2 mb-2">
                                {existingImages.map((img, index) => (
                                    <img
                                        key={index}
                                        src={getImageUrl(img)}
                                        alt={`Existing ${index}`}
                                        className="w-auto h-16 sm:h-20 object-cover rounded"
                                        onError={(e) => {
                                            console.error(`Failed to load image: ${getImageUrl(img)}`);
                                            e.target.src = '/fallback-image.jpg'; // Fallback image
                                        }}
                                    />
                                ))}
                            </div>
                        ) : (
                            <p className="text-gray-500 text-sm sm:text-base">
                                No existing images
                            </p>
                        )}
                        <label
                            className="block text-[#12392B] text-sm sm:text-base mb-1 sm:mb-2"
                            htmlFor="images"
                        >
                            Upload New Images (up to 5)
                        </label>
                        <input
                            type="file"
                            id="images"
                            multiple
                            accept="image/*"
                            onChange={handleImageChange}
                            className="w-full p-2 sm:p-3 border border-gray-300 rounded text-sm sm:text-base"
                            aria-label="Upload New Images"
                        />
                    </div>
                    <div className="flex justify-end space-x-2">
                        <button
                            type="button"
                            onClick={onClose}
                            className="bg-gray-500 text-white p-2 sm:p-3 rounded hover:bg-gray-600 transition text-sm sm:text-base"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="bg-[#12392B] text-white p-2 sm:p-3 rounded hover:bg-[#E6A71A] hover:text-[#12392B] transition text-sm sm:text-base"
                        >
                            Update Event
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UpdateAdminEvents;